import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import HookFormSelectInput from 'src/hook-form-wrapper/select-input';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
}

export const programTypeArray = [
  {label: 'Behavior', title: 'Behavior', value: 'behavior'},
  {label: 'Skill Acquisition', title: 'Skill Acquisition', value: 'skill'},
];

export const Import = (
  key: string = 'type',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Program Type',
  key,
  type: 'select',
  selectOptions: programTypeArray,
  validators: [
    {
      validate: 'required',
    },
  ],
});

export const Value = (value: string) => {
  return programTypeArray.find(item => item.value === value)?.label;
};

export const Display = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Program Type</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name}: Props) => {
  return (
    <HookFormSelectInput
      name={(name ? name + '.' : '') + 'type'}
      label={'Program Type'}
      required={false}
      items={programTypeArray}
    />
  );
};

export const validation = () =>
  Yup.string().required('Program Type is required');

export default Input;
